import React, { useEffect, useState } from "react";
import { Stack, LinearProgress, Button, Modal, Container, Box  } from "@mui/material";
import OnboardingState from "./hoa-onboarding-state";
import HoaOnboardingModalEdit from "./hoa-onboarding-modal-edit";
import HoaOnboardingModalView from "./hoa-onboarding-modal-view";

export default function HoaOnboardingDetailsModal({ isModalOpen, handleModalClose, cancelBtnClicked, markAsCompletedBtnClicked, activeState, isEditMode, onboardingDocuments, setOnboardingDocuments, onboardingDataState, setOnboardingDataState, nextBtnClicked, previousBtnClicked, isMarkAsCompletedBtnEnabled, shouldUpdateAvailable}: any) {
    const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(false);

    useEffect(() => {
        let isEnabled = false;

        if (onboardingDocuments) {
            if (activeState == 1) {
                const data = onboardingDataState["clientDirectory"]?.data;
    
                if (onboardingDocuments["clientDirectory"]?.length > 0
                    || data["hyperLink"] || data["remarks"] || data["isDataUnavailable"]) {
    
                    isEnabled = true;
                }
            }
            else if (activeState == 2) {
                const data = onboardingDataState["portalSearch"]?.data;
                
                if (onboardingDocuments["portalSearch"]?.length > 0 
                    || data["portalLink"] || data["remarks"] || data["isDataUnavailable"]) {
                        
                    isEnabled = true;
                }
            }
            else if (activeState == 3) {
                const data = onboardingDataState["emailHoa"]?.data;
    
                if (onboardingDocuments["emailHoa"]?.length > 0 || onboardingDocuments["emailHoaScreenshot"]?.length > 0
                    || data["emailSourceId"] || data["obtainedInformation"] || data["remarks"]) {
                        
                    isEnabled = true;
                } 
            }
            else if (activeState == 4) {
                const data = onboardingDataState["callHoa"]?.data;
    
                if (onboardingDocuments["callHoa"]?.length > 0 || onboardingDocuments["callHoaScreenshot"]?.length > 0
                    || data["phone"] || data["email"] || data["obtainedInformation"] || data["remarks"]) {
                        
                    isEnabled = true;
                }
            }
        }

        setIsUpdateButtonEnabled(isEnabled);
    }, [onboardingDataState, onboardingDocuments]);

    return(
        <Modal open={isModalOpen} onClose={handleModalClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "785px",
					overflow: "auto",
					borderRadius: "4px",
					padding: "0px",
				}}
			>
                <div style={{ padding: "27px 16px", background: "#EFF4FC", border: "1px solid #E8E8E8" }}>
                    <Box sx={{ fontWeight: '500', color: '#3E3E3E', fontSize: "20px", display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                        <Box>Onboarding HOA </Box>
                        <Box>Onboarding Date: {(onboardingDataState?.clientDirectory?.onboardingDate === '' || !onboardingDataState?.clientDirectory?.onboardingDate) ? 'N/A': onboardingDataState?.clientDirectory?.onboardingDate?.replace(/\./g, '/')}</Box>
                    </Box>
                </div>
				<div style={{ display: "flex" }}>
					<div style={{ width: "240px", background: "#E8E8E8", height: "570px", padding: "16px", display: "flex", flexDirection: "column"  }}>
                        <OnboardingState isCompleted={onboardingDataState["clientDirectory"].isCompleted} isActive={activeState == 1} stateNumber={1} stateName={"Client's Directory"} componentWidth={"180px"} justifyContent={"flex-start"}/>
                        <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', width: '40px' }}><div style={{ color: 'black', width: '1px', height: "20px", background: "#C5C5C5", margin: "5px 0px 5px 0px" }}/></div>
                        
                        <OnboardingState isCompleted={onboardingDataState["portalSearch"].isCompleted} isActive={activeState == 2} stateNumber={2} stateName={"Portal Search"} componentWidth={"180px"} justifyContent={"flex-start"}/>
                        <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', width: '40px' }}><div style={{ color: 'black', width: '1px', height: "20px", background: "#C5C5C5", margin: "5px 0px 5px 0px" }}/></div>

                        <OnboardingState isCompleted={onboardingDataState["emailHoa"].isCompleted} isActive={activeState == 3} stateNumber={3} stateName={"Email HOA"} componentWidth={"180px"} justifyContent={"flex-start"}/>
                        <div style={{ display: "flex", justifyContent: 'center', alignItems: 'center', width: '40px' }}><div style={{ color: 'black', width: '1px', height: "20px", background: "#C5C5C5", margin: "5px 0px 5px 0px" }}/></div>

                        <OnboardingState isCompleted={onboardingDataState["callHoa"].isCompleted} isActive={activeState == 4} stateNumber={4} stateName={"Call HOA"} componentWidth={"180px"} justifyContent={"flex-start"}/>
                    </div>
                    <div style={{ height: "570px", padding: "16px", width: "545px", overflow: "auto" }}>
                        {
                            isEditMode ?
                            <HoaOnboardingModalEdit activeState={activeState} onboardingDocuments={onboardingDocuments} setOnboardingDocuments={setOnboardingDocuments} onboardingDataState={onboardingDataState} setOnboardingDataState={setOnboardingDataState} shouldUpdateAvailable={shouldUpdateAvailable}/>
                            :
                            <HoaOnboardingModalView activeState={activeState} onboardingDataState={onboardingDataState}/>
                        }
                    </div>
				</div>
                <div style={{ height: "45px", padding: "16px", display: "flex", justifyContent: "space-between", border: "1px solid #E8E8E8" }}>
                    {
                        isEditMode ?
                        <>
                            <Button onClick={() => cancelBtnClicked()} variant="outlined">
                                Cancel
                            </Button>
                            {
                                shouldUpdateAvailable(activeState) ?
                                <Button onClick={markAsCompletedBtnClicked} variant="contained" disabled={!isUpdateButtonEnabled}>
                                    Update
                                </Button>
                                :
                                <Button onClick={markAsCompletedBtnClicked} variant="contained" disabled={!(isMarkAsCompletedBtnEnabled && isMarkAsCompletedBtnEnabled())}>
                                    Mark As Complete
                                </Button>
                            }
                        </>
                        :
                        <>
                            <Button onClick={previousBtnClicked} variant="contained" disabled={activeState === 1}>
                                Previous
                            </Button>
                            <Button onClick={nextBtnClicked} variant="contained" disabled={activeState === 4}>
                                Next
                            </Button>
                        </>
                    }
                </div>  
			</Container>
		</Modal>
    )
}